import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const AccessoryItems = lazy(() => import('./AccessoryItems'));
const AccessoryItemsListView = lazy(() => import('./views/AccessoryItemsListView'));
const AccessoryItemFormView = lazy(() => import('./views/AccessoryItemFormView'));

const AccessoryItemsRoute: FuseRouteItemType = {
	path: '/accessory-items',
	element: <AccessoryItems />,
	children: [
		{ index: true, element: <AccessoryItemsListView /> },
		{ path: 'new', element: <AccessoryItemFormView /> },
		{ path: ':id', element: <AccessoryItemFormView /> }
	]
};

export default AccessoryItemsRoute;
